export const SELECTS_OPTIONS = [
  {
    label: 'label 1',
    value: '1',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 2',
    value: '2',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 3',
    value: '3',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 4',
    value: '4',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 5',
    value: '5',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 6',
    value: '6',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 7',
    value: '7',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 8',
    value: '8',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 9',
    value: '9',
  },
  {
    avatar: {
      src: 'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png',
    },
    label: 'label 10 loooooooooooooooooooooooooooooooooooooooooooooong label',
    value: '10',
  },
]
